module.exports = "/_next/static/images/alexandra-halliday-cade99f5ff4ebe032d91a3d86e4f221c.jpeg";